import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.99975 16.0002C2.99975 15.7443 3.09775 15.4882 3.29275 15.2933L11.2928 7.29325C11.6838 6.90225 12.3158 6.90225 12.7067 7.29325L20.7068 15.2933C21.0978 15.6842 21.0978 16.3162 20.7068 16.7072C20.3158 17.0982 19.6838 17.0982 19.2928 16.7072L11.9998 9.41425L4.70675 16.7072C4.31575 17.0982 3.68375 17.0982 3.29275 16.7072C3.09775 16.5122 2.99975 16.2562 2.99975 16.0002Z",
		fill: "currentColor"
	})
});
export default SvgArrowUp;
